import { useNavigate } from "react-router-dom";
import { PowerOff, Lock, ArrowLeft, LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Shown instead of silently bouncing when an app's page is closed. */
export default function AppUnavailable({ appName = "", inactive = true }) {
  const navigate = useNavigate();
  const Icon = inactive ? PowerOff : Lock;
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4" data-testid="app-unavailable">
      <div className="w-full max-w-lg rounded-2xl border border-border bg-card p-10 shadow-sm">
        <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-amber-500/10 text-amber-600 dark:text-amber-300">
          <Icon className="h-6 w-6" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-foreground" data-testid="app-unavailable-title">
          {inactive
            ? `${appName || "This app"} is switched off`
            : `You don't have access to ${appName || "this app"}`}
        </h1>
        <p className="mt-3 text-sm text-muted-foreground" data-testid="app-unavailable-message">
          {inactive
            ? "An administrator has set this app to Inactive, so its pages are closed for everyone — including super admins. Flip it back to Active in Settings → Apps to reopen it."
            : "Your role doesn't include this app. If you think that's wrong, ask an administrator to grant it to your role."}
        </p>
        <div className="mt-8 flex flex-wrap gap-2">
          <Button onClick={() => navigate("/dashboard")} data-testid="app-unavailable-dashboard"
            className="bg-primary text-primary-foreground hover:bg-primary/90">
            <ArrowLeft className="h-4 w-4" /> Back to dashboard
          </Button>
          {inactive && (
            <Button variant="outline" onClick={() => navigate("/apps")} data-testid="app-unavailable-settings">
              <LifeBuoy className="h-4 w-4" /> Open Settings → Apps
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
